import { table } from './_table';

export const numbers = {
  namespaced: true,
  modules: {
    table
  }
};
